module.exports = __webpack_public_path__ + "static/img/logo_big.21fb489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_big.png
// module id = XaOh
// module chunks = 6